import { render, staticRenderFns } from "./interactionEn.vue?vue&type=template&id=ec5f33bc&scoped=true"
import script from "./interactionEn.vue?vue&type=script&lang=js"
export * from "./interactionEn.vue?vue&type=script&lang=js"
import style0 from "./interactionEn.vue?vue&type=style&index=0&id=ec5f33bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5f33bc",
  null
  
)

export default component.exports